import { createBrandTile } from './brandTile';

/**
 * Merges OEM logo tiles and custom logo tiles alphabetically by name.
 *
 * @param {Array<Object>} oemLogos - OEM tiles shaped as { brand: { name, brandLogoImgUrl, href, showLabel } }
 * @param {Array<Object>} customItems - Custom items from item-list-service: { name, logoUrl }
 * @param {boolean} showLabel - Whether to show the tile label
 * @returns {Array<Object>} Merged and alphabetically sorted tile array
 */
export const mergeLogos = (
	oemLogos = [],
	customItems = [],
	showLabel = false
) => {
	const customTiles = customItems.map(({ name, logoUrl }) =>
		createBrandTile(name, logoUrl, showLabel)
	);

	return [...oemLogos, ...customTiles].sort((a, b) =>
		(a.brand.name || '').localeCompare(b.brand.name || '', undefined, {
			sensitivity: 'base'
		})
	);
};
